export const masterData: Record<string, string> = {
  Company: 'Vállalat',
  'Additional files are retained in the original archive. Import BCF separately if needed:':
    'A további fájlok az eredeti archívumban maradnak. A BCF külön importálható:',
  'E-mail': 'E-mail',
  Error: 'Hiba',
  File: 'Fájl',
  'IFC entry': 'IFC-fájl',
  'IFC file inside archive': 'IFC-fájl az archívumban',
  'KiB)': 'KiB)',
  MB: 'MB',
  'Model / revision': 'Modell / változat',
  'Model import progress / Modellimport állapota': 'Modellimport állapota',
  'New model': 'Új modell',
  'New revision:': 'Új változat:',
  Parent: 'Szülőelem',
  Root: 'Gyökérelem',
  'Select IFC file': 'IFC-fájl kiválasztása',
  'Select a project first.': 'Először válasszon projektet.',
  'Start import': 'Importálás indítása',
  'Upload and validate': 'Feltöltés és ellenőrzés',
  ARCHIVED: 'Archivált',
  BUILDING: 'Épület',
  FLOOR: 'Szint',
  ROOM: 'Helyiség',
  LOCATION: 'Helyszín',
  CARRIER: 'Fuvarozó',
  MATERIAL_SUPPLIER: 'Anyagbeszállító',
  Current: 'Aktuális',
  'Import IFC / IFCZIP': 'IFC / IFCZIP importálása',
  'Import BCF': 'BCF importálása',
  SITE: 'Terület',
  WING: 'Épületszárny',
  ZONE: 'Zóna',
  UNIT: 'Egység',
  ELEMENT: 'Elem',
};
